import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import {
	provideEventSpinningText,
	getSpinningTextVars,
} from '@/features/sports/components/spinning-texts/event-spinning-text';
import { SportEventV2, SportEventStatus } from '@/@types/graphql-types';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventSpinningText',
  props: {
    event: null,
    eventTitle: null,
    status: null,
    date: null,
    time: null
  },
  setup(__props: any) {

const props = __props as {
	event: SportEventV2;
	eventTitle: string;
	status: SportEventStatus;
	date?: string;
	time?: string;
};



const { language } = useLanguageStore();
const { t, tc } = useI18n();
const route = useRoute();

const spinningText = computed(() => {
	const { heading, content } = provideEventSpinningText(
		props.status,
		props.eventTitle,
		props.date,
		props.event.offers
	);
	return {
		heading: t(heading, spinningTextVars.value),
		content: content.map(text => t(text, spinningTextVars.value)).join(' '),
	};
});

const spinningTextVars = computed(() => {
	return getSpinningTextVars(
		language.value,
		props.event.offers,
		props.event.watchNowOffer,
		props.eventTitle,
		tc(`SPORTS_WEBAPP_SPORT_TYPE_${route.meta!.sport}`),
		props.date,
		props.time
	);
});

return { __sfc: true,props, language, t, tc, route, spinningText, spinningTextVars }
}

})